<template src="./index.html"></template>

<script>
	import {getdata} from "./data.js";
	import {
		hgjks_query
	} from "../../../../../api/hgjks.js";
	import config from "../../../../../../configHttp.js";
	import {
		MainFunction
	} from "@/components/util/Function/MainFunction";
	export default {
		data: function() {
			return {
				searchdata: getdata().searchdata,
				searchlist: getdata().searchlist,
				outlist: [],
				headData: getdata().headData,
				pagination: getdata().pagination,
				tableData: getdata().tableData,
				shaidiag: false,
				searchdiag: false,
				// 日期控件初始化时间
				dateValue: MainFunction.$getdefultMonth(),
				// 导出传参类型
				outputData: getdata().outputData,
				// 全部导出
				exportType: "1",
				tablekey: 0,
			};
		},
		methods: {
			sizechange(e) {
				this.pagination.pageSize = e;
				this.fetchResultShow();
			},
			currentChange(e) {
				this.pagination.pageNum = e;
				this.fetchResultShow();
			},
			submitSearch() {
				this.pagination.pageNum = 1;
				this.pagination.paginationkey++;
				this.fetchResultShow();
			},
			forRefresh() {
				this.pagination.pageNum = 1;
				this.pagination.paginationkey++;
				this.fetchResultShow();
			},

			forUpdateSearch() {
				this.searchdiag = true;
			},
			closeSearch() {
				this.searchdiag = false;
			},
			saveChange(e) {
				this.searchdiag = false;
			},
			confirmfilter(e) {
				this.headData = e.chooselist;
				this.outlist = e.nochooselist;
				this.shaidiag = false;
			},
			closeshaidiag() {
				this.shaidiag = false;
			},

			// 查询进行发票合计结果(分页)
			fetchResultShow() {
				let params = {
					suosq: this.dateValue,
				};
				params.current = this.pagination.pageNum;
				params.size = this.pagination.pageSize;
				params.sort = "";
				params.order = "";
				hgjks_query(params).then((res) => {
					this.pagination.total = res.data.data.total;
					this.pagination.paginationkey++;
					this.tableData = res.data.data.records;
				});
			},
			suosqchange() {
				this.fetchResultShow();
			},
			// 导出进项发票合计结果
			outPutIInvResult() {
				let selectVal = this.$refs.tablebox.getSelectionval();
				let data = {
					suosq: this.dateValue
				};
				if (selectVal.length > 0) {
					data.companyCodes = selectVal.map((item) => item.companyCode);
				}
				let params = {
					downUrl: config.baseURL + "hgjks/list/export",
					typeObj: {
						toForm: false,
						fileName: "海关缴款书结果展示" + this.$timestampToStr(new Date(), "yyyyMMdd"),
						fileType: "xlsx",
						failUrl:this.$winURl
					},
					params: data,
				};
				this.$downloadcommon(params);
			},
		},
		components: {},
		created() {
			this.fetchResultShow();
		},
		mounted() {},
		computed: {
			timeDefault() {
				let date = new Date();
				let newDate = date.getFullYear() + "年" + (date.getMonth() + 1) + "期";
			},
		},
	};
</script>

<style scoped lang="less">
	@import url("./index.less");
</style>
